export default __webpack_public_path__ + "static/service5-593f336e95a31dd3f25d7f847c3922d5.png";